__turbopack_context__.v({
  "link": "ThingsToDoShelfContainer-module-scss-module__fYZpNq__link",
  "root": "ThingsToDoShelfContainer-module-scss-module__fYZpNq__root",
  "title": "ThingsToDoShelfContainer-module-scss-module__fYZpNq__title",
});
